// extracted by mini-css-extract-plugin
export default {"Card":"card_Card__j3nSV","CardPrimary":"card_CardPrimary__hEYYi","CardTitle":"card_CardTitle__4FjQn","CardDisabled":"card_CardDisabled__ktpEi"};